import { AppRoutes } from '@/constants/appRoutes'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
export const ForgotPaswordCheckYourInbox = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const handleBack = () => {
    navigate(AppRoutes.registerStart)
  }
  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-8">
      <div className="flex flex-col gap-3 w-full max-w-[500px] bg-baseColorHighlight p-8 border border-neutralColor5 rounded-3xl">
        <p className="text-[32px] max-md:text-2xl font-medium tracking-wide text-center">
          {t('auth.forgotPassword.checkYourInbox')}
        </p>
        <p className="text-base font-normal tracking-tight max-md:text-sm text-center">
          {t('auth.forgotPassword.checkYourInboxText')}
        </p>
      </div>
      <p
        className="text-center font-medium text-base text-neutralColor80 hover:text-neutralColor60 hover:cursor-pointer"
        onClick={handleBack}
      >
        {t('common.back')}
      </p>
    </div>
  )
}
